import { handleAllocationScenario } from ".";
import {
  FutureIncomeResponse,
  ScenariosCoefficientsResponse,
  ScenarioValuesResponse,
} from "../../../../generated-api-v3";

export function riskAllocationMapping(
  data: ScenarioValuesResponse | ScenariosCoefficientsResponse | undefined,
  usingApiValues: boolean = false,
  options: {
    colors?: string[];
    priceMultiplier: number;
    fxMultiplier: number;
    yieldMultiplier: number;
    volatilityMultiplier: number;
  },
  incomeData: FutureIncomeResponse | undefined
) {
  const sectorsMaps = handleAllocationScenario(
    data?.sectors,
    usingApiValues,
    "Sector",
    options,
    incomeData
  );
  const assetClassesMaps = handleAllocationScenario(
    data?.assetClasses,
    usingApiValues,
    "Asset Class",
    options,
    incomeData
  );
  const countriesMaps = handleAllocationScenario(
    data?.countries,
    usingApiValues,
    "Country",
    options,
    incomeData
  );
  const currenciesMaps = handleAllocationScenario(
    data?.currencies,
    usingApiValues,
    "Currency",
    options,
    incomeData
  );
  const custodiansMaps = handleAllocationScenario(
    data?.custodians,
    usingApiValues,
    "Custodian",
    options,
    incomeData
  );

  console.log({
    sectorsMaps,
    custodiansMaps,
    currenciesMaps,
    assetClassesMaps,
    countriesMaps,
  });

  return {
    sectorsMaps,
    custodiansMaps,
    currenciesMaps,
    assetClassesMaps,
    countriesMaps,
  };
}
